// This was re-located from `@app/client` in order to
// resolve circular dependency issues.
export enum ActivityStatusType {
    Listed = 'listed',
    Bid = 'bid',
    Transfer = 'transfer',
    Sale = 'sale',
    Buy = 'buy',
    Mint = 'mint',
    Offer = 'offer',
    FloorPrice = 'FloorPrice',
    Burn = 'burn',
}
